module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2 other-techs",
    staticStyle: {
      "margin-bottom": "30px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top-center",
      value: ('<strong>' + _vm.footer + '</strong><br>' + _vm.header),
      expression: "'<strong>' + footer + '</strong><br>' + header",
      modifiers: {
        "top-center": true
      }
    }]
  }, [_vm._t("svg")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76756f20"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/technology/components/other-tech.vue
// module id = 313
// module chunks = 1